<template>
	<div class="w-full flex gap-3 px-4">
		<div class="w-full flex flex-col items-start gap-5">
			<div class="w-6/12">
				<div class="flex align-items-center justify-content-start">
					<div class="pl-0 mr-2 col-auto">
						<div
							class="font-32"
							:class="{
								'text-primary': invoice_scheduling,
								'text-secondary': !invoice_scheduling,
							}"
							@click="ToggleInvoiceScheduling"
						>
							<i
								class="fad"
								:class="{
									'fa-toggle-on': invoice_scheduling,
									'fa-toggle-off': !invoice_scheduling,
								}"
							></i>
						</div>
					</div>
					<label
						class="mb-0 text-dark font-bold"
						@click="ToggleInvoiceScheduling"
					>
						FATURAMENTO NO AGENDAMENTO
					</label>
				</div>
				<p class="text-start">
					HABILITE ESTA OPÇÃO PARA REALIZAR O FATURAMENTO DOS PROCEDIMENTOS NO MOMENTO DO AGENDAMENTO QUANDO
					FOR PRONTO ATENDIMENTO OU ENCAIXE, E NA CONFIRMAÇÃO QUANDO FOR PRÉ-AGENDAMENTO.
				</p>
			</div>
		</div>
		<div class="w-full flex flex-col items-start gap-5">
			<div class="w-6/12">
				<div class="flex align-items-center justify-content-start">
					<div class="pl-0 mr-2 col-auto">
						<div
							class="font-32"
							:class="{
								'text-primary': content_subscription,
								'text-secondary': !content_subscription,
							}"
							@click="ToggleContentSubscription"
						>
							<i
								class="fad"
								:class="{
									'fa-toggle-on': content_subscription,
									'fa-toggle-off': !content_subscription,
								}"
							></i>
						</div>
					</div>
					<label
						class="mb-0 text-dark font-bold"
						@click="ToggleContentSubscription"
					>
						SINCRONIZAÇÃO DE CONTEÚDO
					</label>
				</div>
				<p class="text-start">HABILITE ESTA OPÇÃO PARA MANTER O CONTEÚDO MÉDICO ATUALIZADO CONSTANTEMENTE.</p>
			</div>
		</div>
		<div class="w-full flex flex-col items-start gap-5">
			<div class="w-6/12">
				<div class="flex align-items-center justify-content-start">
					<div class="pl-0 mr-2 col-auto">
						<div
							class="font-32"
							:class="{
								'text-primary': report_return,
								'text-secondary': !report_return,
							}"
							@click="ToggleReportReturn"
						>
							<i
								class="fad"
								:class="{
									'fa-toggle-on': report_return,
									'fa-toggle-off': !report_return,
								}"
							></i>
						</div>
					</div>
					<label
						class="mb-0 text-dark font-bold"
						@click="ToggleReportReturn"
					>
						RETORNO DE LAUDO(MOBILEMED)
					</label>
				</div>
				<p class="text-start">HABILITE ESTA OPÇÃO PARA RECEBER O RETORNO DE LAUDO DO MOBILEMED.</p>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'
	import Swal from 'sweetalert2'
	import _ from 'lodash'

	export default {
		name: 'Options',
		props: {
			organization: {
				type: Object,
				default: () => {},
				required: true,
			},
		},
		data() {
			return {
				invoice_scheduling: false,
				content_subscription: false,
				report_return: false,
			}
		},
		watch: {
			organization: {
				handler(val) {
					if (!_.isEmpty(val)) {
						this.invoice_scheduling = val?.instances[0]?.config?.invoice_scheduling ?? false
						this.report_return = val?.instances[0]?.config?.report_return ?? false
						this.content_subscription = val?.content_subscription?.sync_enabled ?? false
					}
				},
				immediate: true,
				deep: true,
			},
		},
		methods: {
			...mapActions('auth', ['GetAuthAccount']),
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			ToggleInvoiceScheduling() {
				this.StartLoading()

				return window.api
					.call('post', '/toggle-invoice-scheduling', {
						account_id: this.organization.id,
					})
					.then(({ data }) => {
						if (data.response) {
							this.invoice_scheduling = !this.invoice_scheduling

							this.GetAuthAccount()
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			ToggleContentSubscription() {
				this.StartLoading()

				return window.api
					.call('post', '/toggle-content-subscription', {
						organization_id: this.organization.id,
					})
					.then(({ data }) => {
						if (data.response) {
							this.content_subscription = !this.content_subscription

							this.GetAuthAccount()
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			ToggleReportReturn() {
				this.StartLoading()

				return window.api
					.call('post', '/toggle-report-return', {
						organization_id: this.organization.id,
					})
					.then(({ data }) => {
						if (data.response) {
							this.report_return = !this.report_return

							this.GetAuthAccount()
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
		},
	}
</script>

<style lang="css" scoped>
	.gap-3 {
		gap: 1rem;
	}
</style>
